/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
// Composant
import PapElement from "./PapElement";
// Assets
import Document from "../../../../assets/img/document.png";
// Utils
import {handleDownload} from "../_utils/handleDownloadDocument";
import {formatSQLDateShort} from "../../../../utils/formatSQLDate";
import useWindowDimensions from "../../../../hook/useWindowDimension";

const DocumentList = ({documents, cas, setShowModalNoRerender, showModalNoRerender}) => {
    const {width} = useWindowDimensions();
    const isDocument = documents.find((doc) => doc.type == 0 ? true : false);

    const toggleModal = () => {
        // Affiche la modal d'upload des fichiers
        setShowModalNoRerender(!showModalNoRerender);
    };

    return (
        <div className="listElements">
            <div className="title">
                <span>Vos&nbsp;documents</span>
                <button className="sharedButton white" onClick={toggleModal}>+&nbsp;Ajouter</button>
            </div>
            {!isDocument && width < 599 &&
                <h3 className={"noDocument"}>Aucun document disponible</h3>
            }
            <ul>
                <PapElement cas={cas}/>
                {documents &&
                    // Affiche les documents dans la colone d'info à droite
                    documents.map((doc) => {
                        if (doc && doc.type == 0) {
                            return (
                                <li key={doc.id} onClick={(e) => handleDownload(doc.name, doc.nameOrig)}>
                                    <img src={Document} alt="document"/>
                                    <div>
                                        <h1>{doc.nameOrig}</h1>
                                        <h2>Ajouté le {formatSQLDateShort(doc.dateUpload)}</h2>
                                    </div>
                                </li>
                            );
                        }
                    })}
            </ul>
        </div>
    );
};

DocumentList.propTypes = {
    cas: PropTypes.object,
    documents: PropTypes.array,
    setShowModalNoRerender: PropTypes.func,
    showModalNoRerender: PropTypes.bool,
};

export default DocumentList;
